var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 0C4.67157 0 4 0.67157 4 1.5V4.5C4 5.32843 4.67157 6 5.5 6C6.32843 6 7 5.32843 7 4.5V4H17C17.5523 4 18 3.55229 18 3C18 2.44771 17.5523 2 17 2H7V1.5C7 0.67157 6.32843 0 5.5 0ZM5.5 12C4.67157 12 4 12.6716 4 13.5V16.5C4 17.3284 4.67157 18 5.5 18C6.32843 18 7 17.3284 7 16.5V16H17C17.5523 16 18 15.5523 18 15C18 14.4477 17.5523 14 17 14H7V13.5C7 12.6716 6.32843 12 5.5 12ZM15 9C15 10.1046 14.1046 11 13 11C11.8954 11 11 10.1046 11 9C11 7.89543 11.8954 7 13 7C14.1046 7 15 7.89543 15 9ZM1 2H3V4H1C0.447693 4 0 3.55229 0 3C0 2.44771 0.447693 2 1 2ZM1 14H3V16H1C0.447693 16 0 15.5523 0 15C0 14.4477 0.447693 14 1 14ZM1 10H10.1707C10.0602 9.68723 10 9.35063 10 9C10 8.64937 10.0602 8.31277 10.1707 8H1C0.447693 8 0 8.44771 0 9C0 9.55229 0.447693 10 1 10ZM15.8293 10C15.9398 9.68723 16 9.35063 16 9C16 8.64937 15.9398 8.31277 15.8293 8H17C17.5523 8 18 8.44771 18 9C18 9.55229 17.5523 10 17 10H15.8293Z",
    fill: "#6F6F6F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/setting.72d80093f84da91e6a1c5f864277158b.svg";
export { ForwardRef as ReactComponent };